<script setup lang="ts">
// 電話番号インプット
interface Props {
  modelValue: string;
  id?: string;
  label?: string;
  label2?: string;
  placeholder?: string;
  required?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: "",
  id: "telnum",
  label: "電話番号(ハイフン不要)",
  label2: "",
  placeholder: "電話番号を入力",
  required: false,
});
const emit = defineEmits<{
  "update:modelValue": [modelValue: string];
}>();

if (props.required) {
  useValidatable();
}

const localValue = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    return emit("update:modelValue", newValue);
  },
});

// 電話番号のパターン
const pattern = /^[0-9]+$/;

const isError = ref<boolean>();

function validate() {
  // 必須でなくて値がないとき
  if (!props.required && !props.modelValue) {
    isError.value = false;
    return true;
  }

  // (必須ではないが値はある || 必須で値がない || 必須で値がある) && テストに失敗
  if (!pattern.test(props.modelValue)) {
    isError.value = true;
    return false;
  }

  // テストに合格
  isError.value = false;
  return true;
}

watchDebounced(
  () => localValue.value,
  () => {
    // 値がないときは入力時のvalidateを行わない。submit時のvalidateは実行される
    if (localValue.value) {
      validate();
    }
  },
  { debounce: 500 },
);

defineExpose({ validate });
</script>

<template>
  <div ref="el" class="w-full tablet:max-w-[50%] relative pb-6">
    <FormInputLabel :label="label" :label2="label2" :id="id" />
    <MInput
      v-model="localValue"
      class="w-full block rounded p-2"
      :id="id"
      :placeholder="placeholder"
      :color="isError ? 'error' : 'normal'"
      type="tel"
    />
    <FormAlert
      type="error"
      class="flex items-center absolute bottom-0"
      v-if="isError"
    >
      <Icon class="mr-1 text-sm" size="18" name="mdi:alert-circle" />
      <span>電話番号を半角数字でご入力ください</span>
    </FormAlert>
  </div>
</template>
